/// <amd-module name="Traceability/RunView/Changes/RunViewChanges" />
import React = require("react");
import { ChangesCard } from "Traceability/Changes/ChangesCard";
import { Change, IArtifactServerObject, ITraceabilityCardProps } from "Traceability/Changes/Types";
import { Utilities } from "Traceability/Common/Utilities";
import * as Resources from "Traceability/RunView/Changes/Resources";
// Make sure IRunViewChangesService is registered for FPS
import * as RunViewChangesService from "Traceability/RunView/Changes/RunViewChangesService";
import { IRunViewChangesData, IRunViewChangesService } from "Traceability/RunView/Changes/RunViewChangesService.types";
import { RunViewCommonComponent } from "Traceability/RunView/Common/RunViewCommonComponent";
import { IRunViewCommonData, IRunViewCommonService } from "Traceability/RunView/Common/RunViewCommonService.types";
import { Components, IVssComponentContext } from "VSS/Platform/Layout";

class RunViewChanges extends RunViewCommonComponent<Change> {
    protected get pageTitleText(): string {
        return Resources.RunChangesPageTitleText;
    }

    protected get pageHeaderText(): string {
        return Resources.ChangesPageHeaderText;
    }

    protected get service(): IRunViewCommonService<Change> {
        return this._service as IRunViewCommonService<Change>;
    }

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this._service = this.context.pageContext.getService<IRunViewChangesService>("IRunViewChangesService");
    }

    protected getCards(pageData: IRunViewCommonData<Change>): JSX.Element[] {
        const workItemsPageData: IRunViewChangesData = pageData as IRunViewChangesData;
        const artifactsData = workItemsPageData && workItemsPageData.artifactsData || [];
        const hideCardTitle = artifactsData.length === 1;
        return artifactsData.map((artifactData: IArtifactServerObject<Change>, index: number) => {
            const cardProps: ITraceabilityCardProps<Change> = {
                cardIndex: index,
                innerErrorMessage: artifactData.innerErrorMessage,
                artifactDetails: Utilities.getArtifactDetailsObject<Change>(artifactData, workItemsPageData.currentRunId),
                data: artifactData.data || [],
                getPipelineTypeWorkItems: false,
                getCardData: this._service.getChanges,
                hideCardTitle: hideCardTitle
            };

            return <ChangesCard key={index} {...cardProps} />;
        });
    }

    private _service: IRunViewChangesService;
}

Components.add("TraceabilityRunViewChanges", RunViewChanges);
